module.exports = __webpack_public_path__ + "static/media/background.1199c7fa.svg";